import percent from '@pkg/utils/numbers/percent';
import config from '@/lib/config';
import defaultMetricGroup from '../../utils/defaultMetricGroup';
import updateMetrics from '../shared/updateMetrics';
import updateRootMetrics from '../shared/updateRootMetrics';

/**
 * Derives metrics for the group.
 *
 * @param {Object}
 *
 * @return {Object}
 */
export default function groupMetrics({
  activity,
  role,
  roleSet,
  group,
  groupSet,
  metrics,
}) {
  const isNewRole = roleSet?.has(role?.uuid);
  const isNewGroup = groupSet?.has(group.uuid);
  const isVisibleActivity = activity?.__visibility === config.VISIBILITY.FULL;
  const isVisibleRole = role?.__visibility === config.VISIBILITY.FULL;
  const isVisibleGroup = group.__visibility === config.VISIBILITY.FULL;

  const factor = !activity
    ? 1
    : activity?.hours
      ? percent(activity.hours, role.__hours, 8) / 100
      : 0;

  // Capture metrics for this group.
  const groupMetrics = {
    ...defaultMetricGroup(false),
    budget: isNewRole && role ? role.budget : 0,
    fte: isNewRole && role ? role.fte : 0,
    managers: isNewRole && role?.is_manager ? 1 : 0,
    roles: isNewRole && role ? 1 : 0,
    groups: isNewGroup ? 1 : 0,
    activities: activity ? 1 : 0,
    hours: activity ? activity.hours : 0,
  };

  // Aggregate this group's metrics with the total metrics.
  const total = updateMetrics({
    target: isNewGroup
      ? defaultMetricGroup()
      : { ...group.__metrics.self.total },
    source: {
      ...groupMetrics,
    },
  });

  const visibleMetrics = {
    ...defaultMetricGroup(false),
    activities: isVisibleActivity ? groupMetrics.activities : 0,
    budget: isVisibleRole ? groupMetrics.budget : 0,
    fte: isVisibleRole ? groupMetrics.fte : 0,
    groups: isNewGroup && isVisibleGroup ? groupMetrics.groups : 0,
    hours: isVisibleActivity ? activity.hours : 0,
    roles: isNewRole ? groupMetrics.roles : 0,
    managers: isNewRole && isVisibleRole ? groupMetrics.managers : 0,
  };

  // Aggregate this group's metrics with the visible metrics.
  const visible = updateMetrics({
    target: isNewGroup
      ? defaultMetricGroup()
      : { ...group.__metrics.self.visible },
    source: { ...visibleMetrics },
  });

  if (isNewGroup) {
    updateRootMetrics({
      entityMetrics: {
        ...defaultMetricGroup(),
        groups: isNewGroup ? 1 : 0,
      },
      visibleMetrics: {
        ...defaultMetricGroup(),
        groups: visibleMetrics.groups,
      },
      metrics,
    });
  }

  return { total, visible };
}
